import CAApi from './_caApi';

class CAPaymentDetailAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAPaymentDetails';
}

export default new CAPaymentDetailAPI();
